import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=2cc829a4&scoped=true&"
import script from "./TeamCreate.vue?vue&type=script&lang=js&"
export * from "./TeamCreate.vue?vue&type=script&lang=js&"
import style0 from "./TeamCreate.vue?vue&type=style&index=0&id=2cc829a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc829a4",
  null
  
)

export default component.exports